export const id = 'maven';

export const MAVEN_REPO = 'https://repo.maven.apache.org/maven2';
